// For full API documentation, including code examples, visit https://wix.to/94BuAAs
let startDevice = 0;
let startClinic = 0;
let startMoney = 0;
let startVolunteer = 0;
let startState = 0;
let deviceCount = 3750;
let clinicCount = 130;
let moneyCount = 251000;
let volunteerCount = 450;
let stateCount = 26;
const deviceTime = 0.023;
const clinicTime = 41;
const moneyTime = 0.0005;
const volunteerTime = 9.8;
const stateTime = 118.5;
const duration = 1000; // 1000 milliseconds

$w.onReady(function () {
	//TODO: write your page related code here... 
	setInterval(() => {
			countUpDevices();
		}, deviceTime);

});

function countUpDevices() {
	if (startDevice <= deviceCount) {
		$w('#button13').label = startDevice.toString();
		startDevice += 2;
	}
}
$w.onReady(function () {
	setInterval(() => {
			countUpClinics();
		}, clinicTime);
});
function countUpClinics(){
	if (startClinic <= clinicCount) {
		$w('#button14').label = startClinic.toString();
		startClinic++;
	}
}
$w.onReady(function () {
	//TODO: write your page related code here... 
	setInterval(() => {
			countUpMoney();
		}, moneyTime);
});
function countUpMoney(){
	if (startMoney <= moneyCount) {
		$w('#button15').label = "$" + startMoney.toLocaleString().toString();
		startMoney += 100;
	}
}
$w.onReady(function () {
	//TODO: write your page related code here... 
	setInterval(() => {
			countUpVolunteer();
		}, volunteerTime);
});
function countUpVolunteer(){
	if (startVolunteer <= volunteerCount) {
		$w('#button16').label = startVolunteer.toString();
		startVolunteer++;
		//startVolunteer = startVolunteer + 8;
	}
}
$w.onReady(function () {
	//TODO: write your page related code here... 
	setInterval(() => {
			countUpState();
		}, stateTime);
});
function countUpState(){
	if (startState <= stateCount) {
		$w('#button17').label = startState.toString();
		startState++;
	}

}